module.exports = __webpack_public_path__ + "media/chuku1.5056751b.wav";